import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import legacyEn from "./locales/legacy.en.json";
import legacyZh from "./locales/legacy.zh.json";
import zh from "./locales/zh.json";

export const resources = {
  en: { translation: { ...en, ...legacyEn } },
  zh: { translation: { ...zh, ...legacyZh } },
} as const;

export type Locale = keyof typeof resources;
export const LOCALES: Locale[] = ["zh", "en"];
const STORAGE_KEY = "nextsub.locale";

function detectLocale(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "zh") return stored;
  } catch {
    /* storage unavailable */
  }
  const nav = typeof navigator !== "undefined" ? navigator.language : "en";
  return /^zh/i.test(nav) ? "zh" : "en";
}

/** Keys that failed to resolve at runtime; e2e asserts this stays empty. */
export const missingKeys = new Set<string>();

void i18n.use(initReactI18next).init({
  resources,
  lng: detectLocale(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
  saveMissing: true,
  missingKeyHandler: (_lngs, _ns, key) => {
    missingKeys.add(key);
    if (import.meta.env.DEV) console.warn(`[i18n] missing key: ${key}`);
  },
});

function applyHtmlLang(lng: string) {
  if (typeof document !== "undefined") document.documentElement.lang = lng === "zh" ? "zh-CN" : "en";
}
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

if (typeof window !== "undefined") {
  (window as unknown as { __nextsubMissingKeys: Set<string> }).__nextsubMissingKeys = missingKeys;
}

export function setLocale(lng: Locale) {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* ignore */
  }
  void i18n.changeLanguage(lng);
}

export function currentLocale(): Locale {
  return i18n.language === "zh" ? "zh" : "en";
}

export default i18n;
